import zhLocale from 'element-ui/lib/locale/lang/en'
export default {
  "lang": "中文",
  // 菜单
  "menu": {
    "Home": "首页",
    "aboutUs": "关于我们",
    "productPipeline": "产品研发",
    "pipeline": "研发管线",
    "productCenter": "产品中心",
    "scientific": "科研论文发表",
    "platform": "技术平台",
    "service": "研究服务",
    "news": "新闻中心",
    "companyNews": "公司新闻",
    "tradeNews": "行业新闻",
    "recruitment": "人才招聘",
    "contactUs": "联系我们",
  },
  // 首页
  'home': {
    'title': '致力于消化疾病创新药物发展',
    'button': '了解更多'
  },
  // 关于我们
  'aboutUs': {
    'title': '关于我们',
    'introduce': '公司简介',
    'contentOne': "生诺医药成立于2010年，是一家临床阶段的生物医药研发公司。公司聚焦于消化道疾病，肿瘤免疫和自免疾病创新药物研发及产业化，拥有生物创新药技术平台，临床医学研发平台，经验丰富的技术和管理团队以及国际化科学团队，具有原创药的研发能力。",
    'contentTwo': "公司立足国内本土创新发展，具有中国、欧美等多国创新药申报的成功经验。治疗胃酸相关疾病新药利那拉生酯（X842）已成功获批上市，实现商业化和产业化。针对实体瘤治疗的前哨淋巴结T细胞项目具有多种肿瘤的临床IIT研究结果。另外，公司有多项早期阶段的产品管线，包括治疗自免疾病IBD的双特异抗体等。",
    'contentThree': "公司通过与国内外制药企业和研发机构的广泛合作，高速发展，致力于成为中国最有价值的创新药企业。",
    'secondTitle': ""
  },
  // 科研论文发表
  'scientific': {
    'title': '科研论文发表',
  },
  // 研发管线
  "pipeline": {
    'title': '研发管线',
    'contentList': [
      {
        title: "SND001 戊二酸利那拉生酯",
        content:
          "  SND001 利那拉生酯（X842）是全新机制的新一代抑酸药物，属于钾离子竞争性酸阻滞剂（P-CAB），通过竞争性阻断H+,K+-ATP酶中钾离子的活性，发挥抑酸分泌作用。与传统的质子泵抑制剂（PPI）相比，具有起效快，持久和可逆抑制H+,K+-ATP酶的作用，用于胃食管反流(GERD)、消化性溃疡(PUD)、幽门螺杆菌(H.pylori)感染等疾病的治疗。",
      },
      {
        title: "SND002 前哨淋巴结T细胞药物",
        content: `SND002前哨淋巴结T细胞抗肿瘤药物（Sentinel lymph node T cell, SLN-T）是生诺自主研发的具有肿瘤特异性的个体化细胞治疗药物。SND002具有全球范围独立知识产权，获欧盟II期临床试验许可和国家科技重大专项“重大新药创制”支持，目前正在进行中欧临床研究申报。\n       前哨淋巴结（SLN）是T细胞“致敏”（Priming）的场所，富含非耗竭的肿瘤特异性T细胞，经体外活化和扩增，回输至患者体内，能发挥特异性抗肿瘤的功能，用于治疗中晚期恶性实体肿瘤。\n       该项目前期在瑞典Karolinska医学院完成概念验证，在中国完成优化和工艺开发；在中国和欧洲已开展近300例探索性临床研究，结果显示，SLN-T细胞可显著提高晚期实体瘤患者的生存期。`,
      },
      {
        title: "SND005 溶瘤病毒",
        content:
          "SND005溶瘤病毒（Oncolytic virus）是优先感染并杀死肿瘤细胞的一类病毒。初期，部分肿瘤细胞被溶瘤病毒特异性感染和破坏。随后，溶瘤病毒在肿瘤细胞进行复制和增殖，释放出新的感染性病毒颗粒感染和破坏其他肿瘤细胞。溶瘤病毒通过直接溶解肿瘤细胞或者刺激宿主产生抗肿瘤免疫反应来发挥溶瘤的功效。\n        在现今进行的溶瘤病毒类新药中，SND005是唯一的无基因修饰的野生型病毒，至今有14年的临床使用历史，具有安全性高，整体获益率超过40%。显著提高患者存活率4-5倍，在黑色素瘤、胃癌等实体瘤患者中有优异表现。",
      },
      {
        title: "SND006 双特异性抗体",
        content:
          "SND006是生诺医药正在开发的一款国际领先的自身免疫性疾病双特异性抗体药物，首个开发的适应症为炎症性肠病（IBD）。目前已完成单抗的体外功能验证研究，候选抗体分子展现出优于阳性抗体药物的功能。预计将于2026年申报新药临床试验（IND）。SND006靶点组合新颖，潜在适用性广，商业价值高，有望在多种自身免疫性疾病治疗中取得突破。",
      },
    ],
  },
  // 产品中心
  'productCenter': {
    'title': '产品中心',
    'little': "信立安®",
    'topTitle': '戊二酸利那拉生酯胶囊',
    'firstContent': " Linaprazan Glurate Capsules",
    'secondContent': "【注册分类】化学药品1类",
    's1Content': "【适应症】反流性食管炎",
    's2Content': "【规格】50mg",
    's3Content': "【批准文号】国药准字H20240042",
    's4Content': "【上市许可持有人】",
    's5Content': " 地址：中国（上海）自由贸易试验区临港新片区伟展路175号5层504室",
    's6Content': " 电话号码：400-621-9568",
    's7Content': "【生产企业】",
    's8Content': " 名称：上海合全医药有限公司",
    's9Content': " 地址：中国（上海）自由贸易试验区意威路31弄4号",
    'secondTitle': "胃食管反流病",
    'thirdContent': "胃食管反流病（GERD）是一种常见的消化系统疾病，其特点是胃内容物（包括胃酸和胆汁）反流入食管，引起不适症状和（或）并发症。这种病症的主要症状包括烧心和反流，也可能出现胸痛、上腹痛、上腹烧灼感、嗳气等症状。胃食管反流病不仅影响生活质量，还可能引起严重的并发症，如糜烂性食管炎、食管溃疡、食管狭窄，甚至可能增加食管腺癌的风险。因此，及时诊断和治疗非常重要。",
    'extraTitle':"P-CAB 与 PPI 比较",
    'extraList':[
      {
        content:"P-CAB 快速起效，首日即可发挥最佳抑酸效果，快速缓解烧心、反流症状；PPI 起效慢，通常用药几天后才能缓解症状"
      },
      {
        content:"P-CAB 与 CYP2C19 基因多态性无关，疗效个体差异小；PPI 疗效个体差异较大"
      },
      {
        content:"P-CAB 抑酸效果不受饮食影响，依从性更好；PPI 需进餐前半小时服用，依从性相对较差"
      },
    ],
    'extraTwo':"利那拉生酯胶囊市场巨大",
    'extraTwoList':[
      {
        content:"300 亿人民币中国市场，2亿中国人患有胃酸相关疾病，超过1/3的患者服用传统的质子泵抑制剂(PPI)，无法得到充分缓解。",

      },
      {
        content:"利那拉生酯胶囊为1.1类新药，新型钾离子竞争性酸阻断剂（P-CAB）。"
      },
      {
        content:"重磅产品，销售预期每年10-30亿元人民币。"
      }
    ],
    
    'thirdTitle': "中国医药改革20年与戊二酸利那拉生酯胶囊10年发展历程",
    'fourTitle': "每一个重磅的药物发展的背后，都有一个核心团队包括投资人努力奋斗的故事。生诺创建于2010年，创始人胡平生博士，一位拥有丰富国际药物研发经验的药理学家，其创始团队已经开启T细胞肿瘤免疫治疗的研究和新药开发，并获得了国家重大新药专项的支持。由于团队的背景和在新药创新的经验，被邀请参加了多个创新药的国际合作。其中一个就是新一代抗酸药钾离子竞争性酸阻滞剂（P-CAB）利那拉生酯（X842）研究和发展。",
    'fiveTitle': "中国2015年7月22日之前，中国的政策，法规，投资都不支持创新药研发。",
    'sixTitle': " 在2014年的春天，经过近两年的立项调研，生诺在上海繁华的外滩启动了一项重大项目X842的新药研发，策略是在中国开展系统的临床前研究，同时在全球范围内申报1.1类新药，在中国实现全球首发。这一目标尤为宏大，因为直至那时，全球市场上尚未有一款成功上市的钾离子竞争性酸阻滞剂（P-CAB）药物。",
    'sevenTitle': "利那拉生酯这一前体药物的创新之处，在于它是基于活性代谢物linaprazan与戊二酸通过酯键链接形成的特殊分子结构，这一结构设计巧妙，不仅令血药浓度快速达峰，还能有效延长药物的半衰期，从而降低了潜在的不良反应发生率。",
    'eightTitle': "2014年至2017年期间，利那拉生酯项目在中国完成了全部的临床前研究，包括原料药合成、制剂开发、全面的药效学和药代动力学研究，以及符合经济合作与发展组织（OECD）非临床安全性评价（GLP）研究，向中国国家食品药品监督管理局（CFDA）递交了新药临床试验申请（IND），并同步支持了欧洲和美国的新药申报，是第一个在中美欧同步申报的P-CAB类药品。2017年6月，中国正式加入国际人用药品注册技术协调会（ICH），标志着中国新药研究进入国际第一梯队。",
    'nineTitle':"在2023年2月的一个激动人心的日子里，利那拉生酯的上市许可申请正式获得了国家药品监督管理局（NMPA）的受理，其关键的反流性食管炎Ⅱ期和Ⅲ期临床试验均由首都医科大学附属北京友谊医院牵头完成。利那拉生酯实现了首个在中国本土孵化、首个率先在中国完成关键性Ⅲ期临床试验并提交新药上市申请的全球原研药，为该项目后续在亚太和欧美国家的发展奠定了坚实的基础。利那拉生酯的成功研发不仅标志着中国药物研发能力的大幅提升，也体现了中国在创新药物研发领域逐步与国际接轨的坚定步伐。",
    'tenTitle':"利那拉生酯的发展经历了中国创新药的最低谷和高光时刻，起步于痛苦之中，并在痛苦中诞生。其研发始于2015年新药政策改革前夕，当时法规滞后，缺乏投资者支持。临床试验期间，正遇上新冠疫情导致国际国内投资低迷，还遭遇了中美关系紧张和合作伙伴的专利诉讼。然而，生诺最终取得了胜利。利那拉生酯是中国最早期研发的一类新药之一，是中国首批MAH（药品上市许可持有人制度）试点的创新项目，是最早凭借临床前数据申报欧美临床试验的创新药，也是在中国本土研发并实现全球首发的创新药。",
    "elevenTitle":"胡平生博士和他的团队所走过的十年新药研发之路，是一段关于勇气、创新和坚持的旅程。而利那拉生酯的故事，也将激励着未来的科学家们，用知识和智慧，为世界带去更多健康和希望。"
  },
  //  技术平台
  'technologyPlatform': {
    'title': '技术平台',
    'secondTitle': "特点",
    'list': [
      {
        src: new URL("../assets/images/xbpt.jpg", import.meta.url),
        title: "Lymph-T Exp<sup>®</sup> 淋巴结干性T细胞扩增技术平台",
        content:
          "利用生诺自主知识产权的T细胞生产工艺，能够在2周左右将来源于淋巴结的抗肿瘤活性T细胞扩增到百亿级别（扩增5000倍以上），并保持细胞产品的多克隆性、抗肿瘤特异性和T细胞干性，制备成功率90%以上。",
        goodList: [
          {
            text: "高增殖效率",
          },
          {
            text: "丰富的TCR克隆",
          },
          {
            text: "保持T细胞干性",
          },
        ],
      },
      {
        src: new URL("../assets/images/exp-2.png", import.meta.url),
        title: "Immun-marker Hunt 免疫标志物发现平台",
        content:
          "通过对患者免疫细胞和细胞因子的组成、状态、分布进行识别、量化和动态分析，借以推测肿瘤所处微环境的免疫状态，为评估肿瘤治疗效果和制定个体化免疫治疗方案提供预判依据。",
        goodList: [
          {
            text: "疗效判断",
          },
          {
            text: "复发监控",
          },
          {
            text: "方案定制",
          },
        ],
      },
      {
        src: new URL("../assets/images/kypt.png", import.meta.url),
        title: `Neo-Pred<sup>®</sup>新生抗原预测平台`,
        // content:
        //   "通过对患者免疫细胞和细胞因子的组成、状态、分布进行识别、量化和动态分析，借以推测肿瘤所处微环境的免疫状态，为评估肿瘤治疗效果和制定个体化免疫治疗方案提供预判依据。",
        goodList: [
          {
            text: "自主IP的预测算法：预测准确率高，优于现有TESLA（国际新生抗原筛查联盟）准确率；",
          },
          {
            text: "预测范围广：除了可预测传统的点突变，还包括插入缺失、融合、剪切等信息；",
          },
          {
            text: "可应用范围广：包括DNA/RNA疫苗、DC疫苗、新抗原T细胞药物开发；",
          },
        ],
      },
    ],
  },
  // 研究服务
  'researchService': {
    'title': "研究服务",
    'firstTitle': "临床研究项目",
    'lineList': [
      {
        title: "前哨淋巴结T细胞（SLN-T）临床研究",
        index: 0
      },
      {
        title: "自然杀伤细胞（NK cell）临床研究",
        index: 1
      },
      {
        title: "嵌合抗原受体T细胞（CAR-T Cell）临床研究",
        index: 2
      },
      {
        title: "肿瘤浸润淋巴细胞（TIL）临床研究",
        index: 3
      },
      {
        title: "肿瘤生物标志物检测",
        index: 4
      },
    ],
    'secondTitle': '项目简介',
    'line_1': '前哨淋巴结是肿瘤引流器官，接受肿瘤抗原的刺激和致敏，其中含有丰富的特异性抗肿瘤T细胞。然而，在正常状态下，这些细胞受到肿瘤诱导的免疫抑制，不能发挥抗肿瘤功能。',
    'line_2': "该技术能够在手术过程中定位肿瘤前哨淋巴结，并从中分离并筛选出具有特异性抗肿瘤能力的T淋巴细胞，经过大规模体外扩增培养后回输到肿瘤患者体内，辅助标准治疗，持续发挥抗肿瘤作用，并具有免疫记忆效应，能预防肿瘤复发。",
    'line_3': "该技术是瑞典皇家医学院原创项目，发展10余年，投资超过2亿欧元，获得欧盟临床II期资格。在中国继进一步优化、发展，获得科技部“国家重大新药创制”项目及国家自然科学基金等科技项目支助，拥有超过700例的临床研究数据。安全、有效，能延长晚期肿瘤患者一倍以上生存期。",
    'line_4': "自然杀伤细胞（NK cell）是属于淋巴细胞谱系的一类非特异性免疫细胞，是天然免疫系统的重要组成部分，也是人体抵抗感染或抑制肿瘤细胞形成的第一道防线。由于NK细胞无须预先接触抗原即可发挥杀伤作用，因此，NK细胞对病毒感染的细胞，或者肿瘤形成，有着极快的响应速率。同时，NK细胞更有着极强的免疫调节功能，活化后的NK细胞可合成和分泌多种细胞因子，发挥免疫调节作用。",
    'line_5': "本项目从外周血或脐血中筛选出NK细胞，经过刺激和扩增，可获得50亿个以上的NK细胞，回输到体内后通过直接杀伤、分泌细胞因子/趋化因子和形成ADCC（抗体依赖的细胞介导的细胞毒性作用）效应杀伤疾病细胞或间接调节免疫。",
    'line_6': 'CAR-T细胞是一种经过基因工程改造的T细胞，通过引入嵌合抗原受体（CAR）来识别特定的肿瘤相关抗原。CAR-T细胞疗法在肿瘤治疗中显示出巨大潜力，尤其在对抗血液恶性肿瘤如白血病、淋巴瘤等方面。',
    'line_7': "本项目通过采集患者的T细胞，利用基因编辑技术将嵌合抗原受体（CAR）基因导入T细胞中，使得这些T细胞能够特异性地识别并攻击表达特定抗原的肿瘤细胞。通过体外培养和扩增，这些改造后的CAR-T细胞被大量制备，并重新输注回患者体内。在CAR-T细胞治疗过程中，这些经过改造的T细胞在患者体内会寻找并识别表达特定抗原的肿瘤细胞，一旦识别成功，CAR-T细胞就会激活并释放细胞毒性物质来杀死肿瘤细胞。此外，CAR-T细胞还能够通过释放细胞因子等方式激活其他免疫细胞，进一步放大抗肿瘤效果。",
    'line_8': '肿瘤浸润淋巴细胞（TIL）是指来源于患者自身肿瘤组织中的淋巴细胞，这类淋巴细胞近距离接触肿瘤组织，能够识别肿瘤细胞，经分离和体外扩增，回输到体内，可以发挥抗肿瘤效应，在晚期黑色素瘤和宫颈癌等恶性肿瘤的临床研究中，取得了很好的临床效果。',
    'line_9': "本项目获取患者肿瘤组织，经过抗原提取、分离培养，亲和性实验等步骤，纯化并扩增肿瘤浸润淋巴细胞，质检合格后回输给肿瘤患者。该治疗还可以与放、化疗或其他肿瘤免疫治疗方案联用，产生1+1＞2的效果。",
    'line_10': "肿瘤与免疫系统的相互“塑造”和动态变化决定了癌症的发生与转归。针对免疫系统的治疗，革命性地改变了癌症治疗效果和治疗癌症的理念。肿瘤免疫微环境中的免疫细胞和免疫因子的变化是影响肿瘤治疗效果的重要因素。肿瘤免疫监测是对患者免疫细胞和细胞因子的组成、状态、分布进行识别、量化和动态分析，借以推测肿瘤所处微环境的免疫状态，为评估肿瘤治疗效果和制定个体化免疫治疗方案提供辅助依据。",
    'line_11': "本项目应用蛋白质组学，流式细胞学，荧光免疫组化，转录组学和实验动物学等多种先进的技术平台，全景式描绘肿瘤患者机体免疫学特征。",
  },
  // 行业新闻
  'industryNews': {
    title: "行业新闻",
    'contentList': [
      {
        title: "2024贵阳∙华人生命科学大会",
        href: 'https://www.csbmb.org.cn/2024SCBA&CBIS',
        content:
          "2024贵阳∙华人生命科学大会（2024 International Conference on Life Sciences, Guiyang, China）将于2024年7月25-30日在贵阳召开（会议详情: https://www.csbmb.org.cn/2024SCBA&CBIS）。本次会议由美洲华人生物科学学会（SCBA）和华人生物学家协会（CBIS）联合主办，贵州大学、贵州医科大学、中国生物化学与分子生物学会、中国细胞生物学学会共同承办。大会围绕生命科学下设多个专题，将集中展示基础生物学、生物医学、病毒和微生物学、农业和植物科学等多个领域的最新研究进展，会议规模约1000人。",
      },
      {
        title:
          "热烈祝贺：西澳科学家马歇尔荣获中国国际科学技术合作奖",
        href: 'https://mp.weixin.qq.com/s/ZUyOKVzELi9vJHSm20iD9g',
        content:
          "2024年6月24日，全国科技大会、国家科学技术奖励大会和中国科学院第二十一次院士大会、中国工程院第十七次院士大会在北京人民大会堂隆重召开。来自澳大利亚西澳大学的临床微生物学教授巴里·马歇尔（Barry J. Marshall）获得“2023年度中华人民共和国国际科学技术合作奖”，成为西澳州第二位、澳大利亚第五位获得该奖的杰出科学家。https://mp.weixin.qq.com/s/ZUyOKVzELi9vJHSm20iD9g",
      },
      {
        title:
          "药监部门批准400多款国产细胞疗法进入临床阶段！",
        href: 'https://mp.weixin.qq.com/s/IinkbrCyQjZUMr9Rl1uK-w',
        content:
          "5月11日北京日报报道：记者从国家药监局获悉，经药品监管部门批准，目前，我国已有四百余个细胞和基因治疗产品正在开展药物临床试验，其中干细胞产品近一百个。适应证涵盖了肿瘤、呼吸系统、神经系统、心血管系统、消化系统、风湿免疫等多类疾病。https://mp.weixin.qq.com/s/IinkbrCyQjZUMr9Rl1uK-w",
      },
      {
        title:
          "百万抗癌针CAR-T如今仅需3万？首款“经济适用型”免疫细胞疗法来了。",
        href: 'https://mp.weixin.qq.com/s/S5qoLfru_Nh7y3ua4zCCtA',
        content:
          "近日，据印度媒体INDIA TODAY报道，印度ImmunoACT细胞科技公司成功研发出一款名为“NexCAR19”的CAR-T免疫细胞疗法，获得印度中央药品标准控制组织（CDSCO）的批准，将正式上市。该疗法主要用于治疗15岁及以上患有复发或难治性（r/r）B细胞淋巴瘤或白血病的患者。NexCAR19标志着印度首个在国内研发并获得批准的人源化CD19靶向的嵌合抗原受体T细胞（CAR-T）疗法。令人瞩目的是，NexCAR19的价格远低于全球其他同类产品。据悉，单次治疗费用仅为3万~4万美元（约合20万~30万人民币），仅为美国同类产品的1/10，国内的1/3。https://mp.weixin.qq.com/s/S5qoLfru_Nh7y3ua4zCCtA",
      },

      {
        title:
          "重大突破！科学家发现156个CAR-T细胞新靶点，有望攻克实体瘤和脑瘤！",
        href: 'https://mp.weixin.qq.com/s/tTh7k8ZMxzsmNwbl4V8TEA',
        content:
          "近日，来自圣裘德儿童研究医院的科学家们取得了重大突破。他们通过整合分析并进行体内实验验证，成功识别出156个潜在的CAR-T细胞治疗靶点。这项研究成果发表在《自然通讯》杂志上，为攻克实体瘤和脑瘤带来了新的希望。https://mp.weixin.qq.com/s/tTh7k8ZMxzsmNwbl4V8TEA",
      },
      {
        title:
          "未来医疗将用细胞治病，一季度我国44款细胞疗法取得临床申报进展。",
        href: 'https://mp.weixin.qq.com/s/iWcAYM0IFKiVA6InAYJs9Q',
        content:
          "2024年我国细胞疗法发展势头持续强劲，在第一季度共有44款细胞疗法取得临床申报进展，包括28款免疫细胞疗法和16款干细胞疗法，给细胞疗法市场注入了新活力。三个月间，CDE共有28项IND获得受理，16项获批IND即将进入临床，整体申报/获批数量相较于去年第一季度增加近20%。https://mp.weixin.qq.com/s/iWcAYM0IFKiVA6InAYJs9Q",
      },
      {
        title:
          "全球首款：Iovance TIL疗法获FDA批准上市",
        href: 'https://mp.weixin.qq.com/s/MxskXsTFdPmMR5gslJAdNA',
        content:
          "2024年2月16日，Iovance Biotherapeutics宣布Lifileucel获得FDA加速批准上市（PDUFA日期为2月24日），用于治疗PD-1抗体治疗后进展的晚期黑色素瘤，商品名为Amtagvi，这也是全球首款获批上市的TIL疗法。https://mp.weixin.qq.com/s/MxskXsTFdPmMR5gslJAdNA",
      },
      {
        title:
          "国家药监局药审中心关于发布 《药物研发与技术审评沟通交流会议申请资料参考》的通知",
        href: 'https://mp.weixin.qq.com/s/7jRIRxwg0EgT3lHB5OmMWw',
        content:
          "为进一步提高沟通交流质量和效率，加大创新研发支持力度，强化对申请人的技术指导和服务，国家药品监督管理局药品审评中心结合沟通交流工作实际和申请人反馈，围绕双方共同提升沟通交流质量和效率的工作需要，分别制定了中药、化学药品、生物制品的药物研发与技术审评沟通交流会议申请资料参考，经征求业界意见完善后，现予发布，供注册申请人准备沟通交流会议申请资料时参考。https://mp.weixin.qq.com/s/7jRIRxwg0EgT3lHB5OmMWw",
      },
      {
        title:
          "国家药监局药审中心关于发布《细胞和基因治疗产品临床相关沟通交流技术指导原则》的通告",
        href: 'https://mp.weixin.qq.com/s/Bzgm7UkbuGPhb0usecN4lQ',
        content:
          "为指导和规范细胞和基因治疗产品临床研发过程中沟通交流的资料准备和临床研发要素考虑等工作，以提高沟通交流效率，促进细胞和基因治疗产品的临床研发，药审中心组织制定了《细胞和基因治疗产品临床相关沟通交流技术指导原则》（见附件）。根据《国家药监局综合司关于印发药品技术指导原则发布程序的通知》（药监综药管〔2020〕9号）要求，经国家药品监督管理局审查同意，现予发布，自发布之日起施行。https://mp.weixin.qq.com/s/Bzgm7UkbuGPhb0usecN4lQ",
      },


      {
        title:
          "12亿美元，阿斯利康收购亘喜生物，加强细胞疗法布局",
        href: 'https://mp.weixin.qq.com/s/zU63d92DnGPBm2kkP5G8bQ',
        content:
          "12月27日，阿斯利康官方发布消息称，阿斯利康已就对亘喜生物科技集团（纳斯达克股票代码：GRCL；简称“亘喜生物”）收购提案签署最终协议，进一步深化阿斯利康在细胞疗法领域布局。亘喜生物是一家面向全球、处于临床阶段的生物制药企业，致力于开发治疗肿瘤及自身免疫性疾病的创新性细胞疗法。https://mp.weixin.qq.com/s/zU63d92DnGPBm2kkP5G8bQ",
      },
      {
        title:
          "11.1亿美元！传奇生物靶向DLL3的CAR-T疗法授权诺华",
        href: 'https://mp.weixin.qq.com/s/MrGp03g5jFMDAA-dKstGQg',
        content:
          "当地时间2023年11月13日，传奇生物（NASDAQ: LEGN）在美国新泽西州萨默塞特正式宣布，其全资子公司传奇生物爱尔兰有限公司（Legend Biotech Ireland Limited）与诺华制药公司（Novartis Pharma AG）就传奇生物的特定靶向 DLL3的嵌合抗原受体T细胞（CAR-T）疗法签订了独家全球许可协议，包括其自体 CAR-T 细胞疗法候选药物 LB2102 （NCT05680922）。该许可协议授予诺华开发、制造和商业化这些细胞疗法的全球独家权利，诺华可以将其T-Charge™平台应用于其生产。https://mp.weixin.qq.com/s/MrGp03g5jFMDAA-dKstGQg",
      },


    ],
  },
  // 公司新闻
  'companyNews': {
    title: "公司新闻",
    'contentList': [
      {
        title: "郭强到贵州生诺生物科技公司调研并主持座谈",
        date: "2024-3-19",
        index: 0,
        content: `  2024年3月18日，贵州省委常委、省委统战部部长郭强到生诺医药调研并主持座谈，强调要发挥法宝作用，用好统战资源，支持民营科技企业，助力新质生产力发展。诺贝尔生理学或医学奖获得者巴里·马歇尔以视频连线交流。（转自贵州日报，网址：http://szb.gzrbs.com.cn/pc/cont/202403/25/content_120579.html）`,
      },
      {
        title: "关注细胞药物发展，共话细胞药物产业挑战",
        date: "2023-12-16",
        index: 1,
        content:
          "2023年 12月15日，第二届深圳龙岗生物医药产业生态大会暨中国医药创新大会在深圳龙岗隆重召开，大会围绕CGT、小分子创新药、高端医疗器械、中药创新、产业资源精准对接等方向，汇聚国内各级政府部门、知名科研院所、联合国项目事务署、行业协会、医药研发企业、投资机构等关键创新主体代表，为生物医药行业呈现了一场深度融合的盛宴，生诺医药受邀参加大会并作大会演讲。",
      },
      {
        title: "生诺医药参加2023亚太消化疾病周学术大会",
        date: "2023-12-10",
        index: 2,
        content:
          "2023亚太消化疾病周（Asian Pacific Digestive Week，APDW）于12月6日至9日在泰国曼谷顺利召开。生诺医药团队受邀前往曼谷进行多项研发展示。本次大会为期四天，百余位全球知名学者围绕消化领域的最新研究发现开展专题报告、学术讨论、壁报展示等交流。生诺医药携X842项目I-III期研究结果参加交流，并与亚洲主要市场国家就X842授权进行了商讨。",
      },
      {
        title:
          "生诺医药受邀参加第八届细胞生物产业大会，分享消化道肿瘤细胞疗法",
        date: "2023-12-1",
        index: 3,
        content:
          "2023年11月29日-30日，CBIC第八届细胞生物产业大会暨第六届中国生物医药创新合作大会在成都盛大召开。此次大会荟聚了行业内众多知名专家、学者与行业大咖，共同探讨细胞创新疗法与应用的前沿资讯，解读细胞产业多领域的政策与趋势。生诺医药受邀参加此次大会，并在会议上做了关于消化道肿瘤免疫细胞药物开发方面的演讲。在本次演讲中，生诺医药重点介绍了公司SND006产品在消化道肿瘤治疗的最新成果和进展。SND006产品是生诺公司全球独家在研的抗肿瘤免疫细胞药物，前期开展的多中心探索性临床试验结果显示该药物在多种实体瘤显示出抗肿瘤效果，是一款潜在突破性的细胞治疗药物。",
      },

      {
        title: "贵州省马歇尔消化疾病研究中心揭牌",
        date: "2023-10-27",
        index: 4,
        content:
          "2023年10月26日，经贵州省委统战部积极推动，贵州省马歇尔消化疾病研究中心在贵州医科大学附属医院揭牌成立。该中心由贵州医科大学附属医院与西澳大学马歇尔中心合作建设，旨在建立一个国际化高水平的医学创新研究平台，探索国际科技合作创新转化新模式。（转自贵州日报，网址：http://szb.eyesnews.cn/pc/cont/202310/27/content_107796.html）",
      },
      {
        title: "生诺医药与三优生物签署战略合作协议",
        date: "2023-8-19",
        index: 5,
        content:
          "2023年8月18日，贵州生诺生物科技有限公司与三优生物医药（上海）有限公司就创新型双抗药物项目签署战略合作协议。这一合作将汇集双方的优势，加速药物研发过程，为患者提供更多、更好的治疗选择。",
      },
      // {
      //   title: "创新药X842项目上市许可申请获得受理",
      //   date: "2023-2-10",
      //   content:
      //     "2023年2月9日，生诺医药开发的新型抑酸剂X842项目的上市许可申请正式获得国家药品监督管理局受理，代表着公司在消化系统疾病领域取得的又一重要里程碑。X842是新一代钾离子竞争性酸阻断剂（P-CAB），具有起效迅速、抑酸作用强且持久、不良反应少等优点。",
      // },
      // {
      //   title:
      //     "上海医药集团股份有限公司关于 X842 项目上市许可申请获得受理的公告",
      //   date: "2023-2-22",
      //   content:
      //     "近日，上海医药集团股份有限公司（以下简称“上海医药”或“公司”）全资子公司上海上药信谊药厂有限公司（以下简称“上药信谊”）合作开发的新型抑酸剂 X842 项目（以下简称“X842”）的上市许可申请正式获得国家药品监督管理局 （以下简称“药监局”）受理。（上海医药集团股份有限公司公告日期： 二零二三年二月二十一日）",
      // },


      {
        title: "生诺生物：深圳路演被评为前三名，受到投资人的广泛关注",
        date: "2023-4-30",
        index: 6,
        content:
          "近日，贵州生诺生物科技有限公司（以下简称“贵州生诺”）董事长胡平生博士参与的“BioFunding易企融资路演”南下“珠三角”第三站路演在深圳落下帷幕。在这场盛大的融资盛宴中，贵州生诺凭借其独特的项目和技术优势，赢得了众多投资机构的青睐。在路演现场，贵州生诺的胡平生博士与知名的投资机构、创业者、学者等汇聚一堂，共同探讨生物科技产业的未来发展方向。他向大家详细介绍了贵州生诺的核心技术和产品，以及公司在市场上的竞争优势和未来发展潜力。",
      },

      {
        title:
          "上海医药集团股份有限公司关于与贵州生诺生物科技有限公司就新型抑酸剂X842项目开展战略合作的公告",
        date: "2021-10-10",
        index: 7,
        content:
          "近日，上海医药集团股份有限公司（以下简称“上海医药”或“公司”） 全资子公司上海上药信谊药厂有限公司（以下简称“上药信谊”）与贵州生诺生物科技有限公司（以下简称“贵州生诺”）及其全资子公司江苏太瑞生诺生物医药科技有限公司（以下简称“江苏生诺”）签订《合作协议》，以不超过人民币（币种下同）6.9 亿元（除销售提成外）的交易金额取得新型抑酸剂 X842 项目（以下简称“X842”）原料药及制剂在中国区域（包括香港、澳门及台湾，下同）的独家委托生产和所有适应症的工业销售权（以下简称“本次交易”）。未来，双方将进一步探讨包括 股权投资、联合开发等形式的合作，加快 X842 及其他在研产品开发和上市工作。 （上海医药集团股份有限公司公布日期：二零二一年十月九日）",
      },
    ],
  },
  //  人才招聘
  'recruitment': {
    'title': "人才招聘",
    'address': "地点：贵阳",
    'firstTitle': '生物药研发总监',
    'jobIntroduce': '岗位职责',
    'topContent': "每一次医药领域的突破都离不开优秀人才的智慧与努力。生诺医药秉持着“科学引领，人才为本”的宗旨，高度重视人才的培养与发展，致力于为每一位员工提供广阔的学习与成长空间。在这里，我们鼓励创新思维，尊重个性发展，倡导团队合作，让每一位员工都能发挥出自己的最大潜能。我们坚信，只有员工与公司共同成长，才能实现公司的持续繁荣。欢迎您加入我们的团队，共同探索生物医药创新的无限可能！",
    'firstContent': '1.负责生物药研究平台的技术方向研究和总体规划，参与组织制订公司技术发展战略；',
    'secondContent': '2.负责公司生物药研发项目的研究立项、申报、设计、优化、监督实施和验收总结；',
    'thirdContent': "3.对项目进度和质量检查，及时提议调整，确保项目按时、保质完成，负责项目成果专利的布局、申请、维护等相关工作和项目相关文献发表；",
    'fourContent': "4.负责研发部门规划、建立、日常管理以及团队人员的建设与培养；",
    'fiveContent': "5.负责带领技术团队独立设计实验、分析实验过程中出现的各种问题，设计、指导关键技术模块，并对安全性、实用性负责，确保公司产品的研发进度。",
    'sixContent': "6.负责研发有关外部对接工作，包括与政府相关管理部门、行业机构公司及其他科研合作单位等。",
    'littleTitle': "任职资格",
    'sevenContent': "1.免疫学、细胞生物学或相关领域博士学历，五年以上相关领域工作经验；或作为主要参与人成功获得一项生物药IND批件；",
    'eightContent': "2.具有丰富的生物药产品研发经验，熟悉生物药相关的各种技术和国内外前沿发展动态；熟悉生物药开发相关政策法规；",
    'nineContent': "3.有独立管理项目的能力，具有生物药的相关研发经验，有成功项目经验优先；",
    'elevenContent': "4.优秀的英文听、说、读、写能力；",
    'firstText': '5.有责任心、敬业精神，具备优秀的团队管理能力、计划和执行能力、组织协调能力和风险控制能力。',
    'secondTitle': "细胞药物项目经理",
    'secondJob': "岗位职责",
    'secondText': "1.跟进和管理细胞类创新药物申报，包括项目内容沟通、项目方案出具沟通修订、Timeline及预算制定与更新、组织内外部项目会议、跟踪项目进度、管理项目开展交付等，支持和监控项目的全生命周期，确保项目按计划完成；",
    'thirdText': "2.负责合同签订后协调合作机构和公司内部各部门的沟通协作，组织定期的与合作机构的沟通会议以及内部的各部门协调会议，按进度要求协调工作；",
    'fourText': "3.负责组织项目立项会，阶段性会和结项会；",
    'fiveText': "4.负责项目风险管理，能够及时敏锐地发现项目执行中遇到的问题，并提出解决方案；",
    'sixText': "5.负责管理维护项目资料，包括数据，技术报告等；",
    'sevenText': "6.上报和解决项目团队问题，组织团队内的决策；",
    'eightText': "7.协助建立项目管理标准化执行流程，完善体系化建设；",
    'nineText': "8.完成上级交办的其他工作。",
    'officeTitle': "任职资格",
    'officeOne': "1.硕士或以上学历，5年以上生物制药领域工作经验；具备药物申报相关工作经验优先；",
    'officeTwo': "2.具备项目管理方面的相关知识，熟悉常用工具；",
    'officeThree': "3.优秀的沟通和协调能力，能够接受出差到项目合作单位实地解决问题；",
    'officeFour': "4.有工艺开发，产品上市和商业项目经验者优先；",
    'officeFive': "5.具有英文读写能力，能以英文进行良好口语沟通优先考虑；",
    'officeSix': "6.具有良好独立工作能力和团队合作精神。",
    'commerceTitle': "商务负责人",
    'commerceJob': "任职要求",
    'commerceOne': "1.协助总经理制定公司发展战略规划、经营计划、业务发展计划；",
    'commerceTwo': "2.根据公司发展战略，梳理项目管线，负责公司项目license-out/in工作，含项目评估、商务谈判、合同签订及合作维护等；",
    'commerceThree': "3.组织并参与公司融资尽调等工作；",
    'commerceFour': "4.负责公司商务人才队伍的建设工作；",
    'commerceFive': "5.完成总经理临时下达的任务。",
    'commerceSix': "1.硕士及以上学历，生物医药相关专业，10-15年医药/生物治疗行业工作背景；",
    'commerceSeven': "2.对公司整体战略有清晰的商务发展思路，能编写商业计划书和可行性研究报告，并进行谈判；",
    'commerceEight': "3.具备良好英文交流和写作水平；",
    'commerceNine': "4.熟悉医药行业的现状和发展趋势，在医药行业有一定的人脉关系和交际网；",
    'commerceTen': "5.工作细致严谨，性格坚韧，思维敏捷，具有高度的工作热情和上进心。",
    'clinicalTitle': "临床研究主管",
    'clinicalOne': "1.负责设计临床试验方案，确保试验的科学性和可行性。根据方案要求，开展临床试验，并严格监控试验过程，确保数据的准确性和可靠性。",
    'clinicalTwo': "2.收集并分析临床试验中的数据，以评估药物的疗效和安全性。根据分析结果，撰写研究报告，为药物的进一步研发和应用提供科学依据。",
    'clinicalThree': "3.根据研究需要，负责检索和整理相关的文献资料，为试验设计和数据分析提供理论支持。",
    'clinicalFour': "4.与团队成员、其他部门以及外部合作伙伴保持密切沟通，确保研究工作的顺利进行。同时，与患者进行沟通，解释试验目的、过程和可能的风险，获取患者的知情同意。",
    'clinicalFive': "1.具备医学、免疫学、细胞生物学或相关领域的硕士及以上学历。",
    'clinicalSix': "2.具有相关领域的工作经验，特别是细胞药物研发或临床试验方面的经验。",
    'clinicalSeven': "3.熟悉细胞药物的研发流程、临床试验规范以及相关的实验技能。具备扎实的理论基础和实践能力，能够独立完成试验设计和数据分析工作。",
    'clinicalEight': "4.具备良好的沟通和协作能力，能够与团队成员、患者以及其他相关方进行有效沟通，确保研究工作的顺利进行。",
    'clinicalNine': "5.具备较强的责任心和职业操守，能够严格遵守研究规范和伦理要求，确保研究结果的准确性和可靠性。",
    'pharmacologicalTitle': "药理研究员",
    'pharmacologicalOne': "1.负责在研项目相关的文献检索、调研等工作；",
    'pharmacologicalTwo': "2.负责进行体内药效、药代等相关研究工作；",
    'pharmacologicalThree': "3.熟悉动物模型建立、各种给药方式及样品采集，操作技术扎实；",
    'pharmacologicalFour': "4.负责临床前药理药效、药代试验方案的初步设计、实施、数据分析、报告撰写等工作；",
    'pharmacologicalFive': "5.负责根据审核通过的动物评价方案组织执行动物评价相关实验，获得真实、可信且准确的评价数据；",
    'pharmacologicalSix': "6.负责撰写工作相关SOP；",
    'pharmacologicalSeven': "7.辅助上级进行相关管理工作。",
    'researcherOne': "1.硕士以上学历，药学、生物学、免疫学、动物医学等相关专业；",
    'researcherTwo': "2.学习能力强，富有责任心，科研素养高，专业基础知识扎实，并有独立解决问题的能力；",
    'researcherThree': "3.良好的沟通能力和有团队合作意识；",
    'researcherFour': "4.良好的英语听说读写能力；",
    'researcherFive': "5.有相关肿瘤动物实验、细胞实验等相关工作经验者优先，可接受优秀应届生；",
    'researcherSix': "6.有发表SCI论文，优先考虑。",
    'assistantTitle': "办公室助理",
    'assistantOne': "1.负责董事长日常行政事务的协调与管理，包括但不限于文件整理、会议组织、行程安排等；",
    'assistantTwo': "2.为公司项目提供技术支持和咨询，包括但不限于项目方案的设计、实验数据的分析解读等；",
    'assistantThree': "3.参与相关的行业文章撰写、专利申请等工作；",
    'assistantFour': "4.参与商务活动，包括商务谈判、会议交流等；",
    'assistantFive': "5.协助完成公司各类英文文件编写，确保内容的准确性与合规性；",
    'assistantSix': "6.协调公司内部各部门之间的工作，确保信息的畅通与准确传递。",
    'assistantSeven': "1.生物医药相关博士专业，英语听说读写能力优秀，有海外留学或工作经验者优先；",
    'assistantEight': "2.能够与公司管理层、业务部门以及其他合作伙伴保持良好的沟通，确保各项工作的顺利进行；",
    'assistantNine': "3.接受出差安排，为公司在各国的业务活动提供支持和协助；",
    'assistantTen': "4.对工作充满责任心，能够高效、准确地完成各项任务。"
  },
  // 联系我们
  'ContactUs': {
    'title': "联系我们",
    'contentList': [
      {
        company: "贵州生诺生物科技有限公司（总部）",
        phone: "0851-84847104",
        email: "info1@sinorda.com",
        address: "贵州省贵阳市国家高新区西部研发基地3栋13层",
        code: "550018",
      },
      {
        company: "江苏太瑞生诺生物医药科技有限公司（子公司）",
        address: "江苏省太仓市生物医药产业园办公楼304室",
        code: "215421",
      },
      {
        company: "上海生诺医药科技有限公司（子公司）",
        address: "上海自由贸易试验区临港新片区伟展路175号5层504室",
        code: "201304",
      },
      {
        company: "SentoClone International AB（瑞典子公司）",
      },
    ],
    'phoneTitle': "电话",
    'emailTitle': "邮件",
    'addressTitle': "地址",
    'codeTitle': "邮编",
    'code': '生诺公众号'
  },
  // 法律声明
  'LegalDetail': {
    'title': "法律声明",
    "contentList": [{
      title: "一、版权声明",
      content: "本网站（以下简称“本站”）上发布的所有内容，包括但不限于文字、图片、视频、音频、图表、软件、程序、数据、资料等，均受著作权法、商标法、专利法等相关法律法规的保护，其著作权、商标权、专利权等知识产权均属于生诺医药公司或其合法权利人所有。"
    },
    {
      title: "二、图片引用声明",
      content: "为了丰富网站内容，本站在部分页面可能引用了来自其他网站的图片。在引用图片时，我们已尽到合理的注意义务，确保所引用的图片不存在侵犯他人著作权的风险。同时，我们也尊重并保护他人的知识产权。如因图片引用问题引发任何纠纷，我们将积极与权利人进行沟通，并承担相应的法律责任。"
    },
    {
      title: "三、新闻链接声明",
      content: "为了向用户提供更全面、更及时的信息，本站在部分页面可能提供了来自其他网页或APP的新闻链接。这些链接所指向的内容由相关网页或APP的运营者负责，与本站无关。我们已尽到合理的注意义务，确保所提供的链接不存在侵犯他人著作权、名誉权等合法权益的风险。但用户在使用这些链接时，仍需自行判断链接内容的合法性、真实性和准确性，并承担因使用链接内容而可能产生的任何后果。"
    },
    {
      title: "四、免责声明",
      content: "1.本站不保证网站内容的准确性、完整性和可靠性，也不对使用网站内容可能产生的任何结果负责。\n        2.本站不保证网站的正常运行，也不对网站因技术故障、网络故障等原因导致的服务中断或延迟负责。\n        3.本站对用户在网站上发布的信息不承担任何审查义务，也不对用户在网站上发布的信息的真实性、合法性、准确性等负责。\n        4.本站对于因用户使用网站内容、链接等而引发的任何纠纷、损失或损害，不承担任何责任。"
    },
    {
      title: "五、知识产权保护",
      content: "我们尊重并保护他人的知识产权。如果您认为本站的内容侵犯了您的知识产权，请您及时与我们联系，我们将尽快处理。同时，我们也呼吁广大用户尊重他人的知识产权，共同维护良好的网络环境。"
    },
    {
      title: "六、法律适用与管辖",
      content: "本法律声明适用中华人民共和国法律。如因使用本网站内容而产生的任何争议，应提交至有管辖权的人民法院诉讼解决。"
    },
    ],
  },
  ...zhLocale
}
